import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ClearFormatting = React.forwardRef((props, ref) => (
  <SvgIcon {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24">
    <g clipPath="url(#clip0_9132_17991)">
      <path
        d="M12.9567 7V16H11.263V7H12.9567ZM15.7507 7V8.34135H8.5V7H15.7507Z"
        fill="#7F91AD"
      />
      <path d="M8.5 12.4254H15.7339" stroke="#7F91AD" strokeWidth="0.5" />
    </g>
    <defs>
      <clipPath id="clip0_9132_17991">
        <path
          d="M0.5 4C0.5 1.79086 2.29086 0 4.5 0H20.5C22.7091 0 24.5 1.79086 24.5 4V20C24.5 22.2091 22.7091 24 20.5 24H4.5C2.29086 24 0.5 22.2091 0.5 20V4Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </SvgIcon>
));

export default React.memo(ClearFormatting);
